import { Component, Input } from '@angular/core';
import { BalanceQuery, config, MemberDetails, MemberQuery } from '@fgb/core';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'fgb-member-card-details',
  templateUrl: './member-card-details.component.html',
  styleUrl: './member-card-details.component.scss',
})
export class MemberCardDetailsComponent {
  @Input() memberCard: MemberDetails;
  @Input() cardImage: string;
  @Input() memberDetails: boolean = true;
  memberDetails$: Observable<MemberDetails | undefined>;
  pointsBalance$: Observable<number | undefined>;
  combinedCard$: Observable<number | undefined>;

  constructor(private memberQuery: MemberQuery, private balanceQuery: BalanceQuery) {}

  ngOnInit() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.pointsBalance$ = this.balanceQuery
      .selectPurse(config.purseConfig.virtualLoyalty)
      .pipe(map((bal) => Math.ceil(bal ?? 0)));
  }
}
